export default "__VITE_ASSET__Be8DaRkp__"